<script context="module" lang="ts">
	declare const __ADMIN__: boolean;
</script>

<script lang="ts">
	import Hydrator from '@reperio-news/core.components/Hydrator.svelte';
	import type { ServerBlockRuntime } from '@reperio-news/core.components/server-blocks.ts';
	export let id: string;
	export let data: { title?: string; message?: string; __runtime?: ServerBlockRuntime } = {};
	type Result = { serverTime: string; requestId: string; domain: string; pathname: string; message: string };
	let loading = false;
	let refreshError = '';
	let announcement = '';
	let stale = false;
	$: runtime = data?.__runtime;
	$: result = runtime?.status === 'success' ? runtime.data as Result : null;

	async function refresh() {
		if (loading || stale || !runtime?.refreshUrl) return;
		loading = true;
		refreshError = '';
		announcement = '';
		try {
			const response = await fetch(runtime.refreshUrl, { cache: 'no-store', signal: AbortSignal.timeout(15000) });
			const next = await response.json();
			if ((response.status === 409 && next.code === 'stale_block') || response.status === 404) {
				stale = true;
				refreshError = 'Pagina s-a modificat. Reîncarcă pagina pentru datele actuale.';
				return;
			}
			if (!response.ok || next.status !== 'success') throw new Error('refresh');
			data = { ...data, __runtime: next };
			announcement = 'Datele au fost actualizate.';
		} catch {
			refreshError = 'Actualizarea nu a reușit. Încearcă din nou.';
		} finally {
			loading = false;
		}
	}
</script>

<Hydrator component="DynamicBlock" props={{ id, data }} hydrate={!__ADMIN__}>
	<section class="af-dynamic" data-dynamic-block aria-busy={loading}>
		<p class="af-dynamic__eyebrow">Date live · demonstrație</p>
		<h2>{data?.title || 'Date dinamice'}</h2>
		{#if __ADMIN__}
			<p>{data?.message || 'Aceste date sunt generate pe server.'}</p>
			<p>Previzualizare editor — deschide previzualizarea paginii pentru date live.</p>
		{:else if result}
			<p>{result.message}</p>
			<dl>
				<div><dt>Ora serverului (UTC)</dt><dd><time data-server-time datetime={result.serverTime}>{result.serverTime}</time></dd></div>
				<div><dt>Identificator cerere</dt><dd data-request-id>{result.requestId}</dd></div>
				<div><dt>Domeniu</dt><dd>{result.domain}</dd></div>
				<div><dt>Pagină</dt><dd>{result.pathname}</dd></div>
			</dl>
		{:else}
			<p role="status">Datele nu sunt disponibile momentan.</p>
		{/if}
		{#if !__ADMIN__ && runtime?.refreshUrl}
			<button type="button" disabled={loading || stale} on:click={refresh}>{loading ? 'Se actualizează…' : 'Actualizează'}</button>
		{/if}
		<p class="af-dynamic__status" role="status" aria-live="polite">{refreshError || announcement}</p>
	</section>
</Hydrator>

<style>
	.af-dynamic { padding: 1.5rem; margin: 1rem 0; min-width: 0; color: var(--af-ink, #14161a); background: var(--af-surface, #fff); border: 1px solid var(--af-hairline, #ded5c6); border-radius: var(--af-radius-card, 12px); font-family: var(--af-font-sans, sans-serif); }
	.af-dynamic__eyebrow { color: var(--af-accent, #9a4e18); font-size: .75rem; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; }
	h2 { font: 600 1.5rem/1.2 var(--af-font-serif, serif); margin: .5rem 0 1rem; }
	p { line-height: 1.6; }
	dl { margin: 1.5rem 0; }
	dl div { padding: .65rem 0; border-bottom: 1px solid var(--af-hairline, #ded5c6); }
	dt { color: var(--af-ink-muted, #5c6169); font-size: .8125rem; }
	dd { margin: .3rem 0 0; font: .875rem/1.6 var(--af-font-mono, monospace); overflow-wrap: anywhere; }
	button { min-height: 44px; padding: .6rem 1.2rem; border: 0; border-radius: var(--af-radius-pill, 999px); background: var(--af-brand, #0e2a47); color: var(--af-ink-inverse, #f7f3ec); font: inherit; cursor: pointer; }
	button:disabled { opacity: .6; cursor: wait; }
	button:focus-visible { outline: 2px solid var(--af-accent, #9a4e18); outline-offset: 3px; }
	.af-dynamic__status { min-height: 1.6em; margin: .75rem 0 0; font-size: .875rem; }
</style>
